import React from "react"
import { withPrefix } from "gatsby"
import Layout from "../components/layout"
import Image from "../components/image"
import Logo from "../components/svg/logo"
import DownloadFullReport from "../components/download-full-report"
import {
  ScrollGallery,
  ScrollGalleryStrip,
  ScrollGalleryMedia,
} from "../components/scroll-gallery"
import ReadNext from "../components/read-next"

export default function Home() {
  return (
    <Layout>
      <section className="page home page--margin-small page--pullBottom">
        <span className="anchor" id="introduction" />
        <div className="container md:container--medium">
          <header className="page__header">
            <div className="page__header__logo">
              <Logo />
              <h1 className="title--m md:title--l">IMF Annual Report 2021</h1>
            </div>
            <DownloadFullReport location="page" />
            <h2
              className="title--xl md:title--xxl lg:title--mondo"
              style={{ marginTop: "1.875rem" }}
            >
              Build Forward Better
            </h2>
          </header>
        </div>
        <div className="container container--full md:container--medium home__intro">
          <p>
            A recovery is underway, but the economic fallout from the global
            pandemic could be with us for years to come.
          </p>
          <p>
            With the crisis exacerbating prepandemic vulnerabilities, country
            prospects are diverging. Nearly half of emerging market and
            developing economies and some middle-income countries are now at
            risk of falling further behind, undoing much of the progress made
            toward achieving the UN Sustainable Development Goals. Within
            countries, inequality is on the rise as well; workers with fewer
            skills, youth, women, and those informally employed are suffering
            disproportionate income losses.
          </p>
        </div>
        <ScrollGallery>
          <ScrollGalleryStrip translateX={160}>
            <ScrollGalleryMedia width="40%">
              <Image path="home/gallery/stripe1_1.jpg" alt="" />
            </ScrollGalleryMedia>
            <ScrollGalleryMedia width="33%" classes="scroll-gallery__video">
              <video
                src={withPrefix("/") + "video/homepage/covid.mp4?v=1"}
                muted
                autoPlay
                loop
                playsInline
              ></video>
              <Image path="home/gallery/stripe1_2.jpg" alt="" />
            </ScrollGalleryMedia>
            <ScrollGalleryMedia width="45%">
              <Image path="home/gallery/stripe1_3.jpg" alt="" />
            </ScrollGalleryMedia>
            <ScrollGalleryMedia width="33%">
              <Image path="home/gallery/stripe1_4.jpg" alt="" />
            </ScrollGalleryMedia>
          </ScrollGalleryStrip>

          <ScrollGalleryStrip translateX={-150}>
            <ScrollGalleryMedia width="33%">
              <Image path="home/gallery/stripe2_1.jpg" alt="" />
            </ScrollGalleryMedia>
            <ScrollGalleryMedia width="50%">
              <Image path="home/gallery/stripe2_3.jpg" alt="" />
            </ScrollGalleryMedia>
            <ScrollGalleryMedia width="45%">
              <Image path="home/gallery/stripe2_4.jpg" alt="" />
            </ScrollGalleryMedia>
            <ScrollGalleryMedia width="60%">
              <Image path="home/gallery/stripe2_5.jpg" alt="" />
            </ScrollGalleryMedia>
            <ScrollGalleryMedia width="60%" classes="scroll-gallery__video">
              <video
                src={withPrefix("/") + "video/homepage/kristalina.mp4?v=3"}
                muted
                autoPlay
                loop
                playsInline
              ></video>
              <Image path="home/gallery/stripe2_2.jpg" alt="" />
            </ScrollGalleryMedia>
          </ScrollGalleryStrip>

          <ScrollGalleryStrip translateX={120}>
            <ScrollGalleryMedia width="40%" classes="scroll-gallery__video">
              <Image path="home/gallery/stripe3_1.jpg" alt="" />
              <video
                src={withPrefix("/") + "video/homepage/solar.mp4?v=1"}
                muted
                autoPlay
                loop
                playsInline
              ></video>
            </ScrollGalleryMedia>
            <ScrollGalleryMedia width="50%">
              <Image path="home/gallery/stripe3_2.jpg" alt="" />
            </ScrollGalleryMedia>
            <ScrollGalleryMedia width="65%">
              <Image path="home/gallery/stripe3_3.jpg" alt="" />
            </ScrollGalleryMedia>
            <ScrollGalleryMedia width="33%">
              <Image path="home/gallery/stripe3_4.jpg" alt="" />
            </ScrollGalleryMedia>
          </ScrollGalleryStrip>
        </ScrollGallery>
        <div className="container container--full md:container--medium home__intro">
          <p>
            Sustaining the recovery will require an ongoing policy push,
            including to secure and expand access to vaccines and to maintain
            economic lifelines and targeted policy support, tailored to the
            stage of the pandemic, the strength of the economic recovery, and
            countries’ structural characteristics. Multilateral cooperation will
            be vital to ensure all countries have equitable access to vaccines
            and financially constrained economies have adequate access to
            international liquidity.
          </p>
          <p>
            As the recovery progresses, economic reforms and public investments
            in human capital and green and digital infrastructure should be
            scaled up to facilitate resource reallocation and limit long-term
            scarring. By building toward a more inclusive, digital, and green
            future, the world’s economies can achieve higher and more durable
            growth.
          </p>
        </div>
      </section>

      <ReadNext sectionID="intro" pageID="message-from-the-md" />
    </Layout>
  )
}
